(function(){
  var WORKER='https://autodonor-vrn-lookup.uaautodonor.workers.dev/';
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f)}

  function cartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('.adh__count').forEach(function(e){e.textContent=c.item_count;e.hidden=!c.item_count});
    }).catch(function(){});
  }

  function plate(){
    var form=document.getElementById('adx-vrn-form');if(!form)return;
    var input=document.getElementById('adx-vrn-input'),btn=document.getElementById('adx-vrn-btn'),res=document.getElementById('adx-vrn-result');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var vrm=input.value.trim();if(!vrm){input.focus();return}
      btn.disabled=true;res.innerHTML='<span style="color:#5b6678">Looking up your car...</span>';
      fetch(WORKER+'?vrm='+encodeURIComponent(vrm)).then(function(r){return r.json()}).then(function(d){
        btn.disabled=false;
        if(d&&d.success){
          var name=[d.make,d.model].filter(Boolean).join(' ');
          var det=[d.year,d.fuel,d.transmission].filter(Boolean).join(' · ');
          res.innerHTML='<div class="adx-vrn-ok"><b>'+esc(name)+'</b><span>'+esc(det)+'</span><a class="adx-btn adx-btn--red" href="/search?type=product&q='+encodeURIComponent(name)+'">Show parts for this car &rarr;</a></div>';
        }else{
          res.innerHTML='<span style="color:#b42318">'+esc((d&&d.message)||'Could not find that plate. Try searching by make and part below.')+'</span>';
        }
      }).catch(function(){btn.disabled=false;res.innerHTML='<span style="color:#b42318">Lookup is unavailable right now. Please search by make and part below.</span>'});
    });
  }

  function nav(){
    var p=location.pathname.replace(/\/$/,'')||'/';
    document.querySelectorAll('.adh__nav a').forEach(function(a){
      var h=(a.getAttribute('href')||'').replace(/\/$/,'')||'/';
      if(h===p)a.classList.add('is-active');
    });
  }

  ready(function(){
    plate();nav();cartCount();
    if(window.subscribe&&window.PUB_SUB_EVENTS&&PUB_SUB_EVENTS.cartUpdate){subscribe(PUB_SUB_EVENTS.cartUpdate,cartCount)}
  });
})();
